import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SubirRecurso from '../Docente/SubirRecurso';
import SubirLibro from '../Docente/SubirLibro';
import RecursosGenerales from '../Docente/RecursosGenerales';
import Perfil from './Perfil';
import UsuariosList from './UsuariosList';

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
  CloseSquareOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons';

import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';

import { Button, Layout, Menu, Switch, ConfigProvider, theme } from 'antd';

const { Header, Sider, Content } = Layout;

const Home = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuKey, setSelectedMenuKey] = useState('3');
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const username = localStorage.getItem('user_name');
  const rol = localStorage.getItem('user_rol'); // Obtener el rol desde localStorage

  // Estado para el modo oscuro
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('darkMode');
    return savedTheme ? JSON.parse(savedTheme) : true;
  });

  // Detectar el tamaño de la pantalla
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Cambiar estado de collapsed cuando la pantalla es pequeña
  useEffect(() => {
    if (screenWidth < 768) {
      setCollapsed(true); // Menú colapsado en dispositivos pequeños
    } else {
      setCollapsed(false); // Menú expandido en dispositivos grandes
    }
  }, [screenWidth]);

  // Guardar el estado de darkMode en localStorage
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  const bgColor = darkMode ? '#1f1f1f' : '#f0f2f5'; // fondo general
  const headerBg = darkMode ? '#141414' : '#fff';   // fondo del header

  const navigate = useNavigate();

  const handleMenuClick = ({ key }) => {
    if (key === '6') {
      localStorage.clear();
      navigate('/');
    } else {
      setSelectedMenuKey(key);
    }
  };

  // Definir las opciones de menú en función del rol
  const menuItems = [
    {
      key: '1',
      icon: <UserOutlined />,
      label: 'Perfil',
      visible: true, // Siempre visible
    },
    {
      key: '2',
      icon: <VideoCameraOutlined />,
      label: 'Recursos Generales',
      visible: true, // Siempre visible
    },
    {
      key: '3',
      icon: <UploadOutlined />,
      label: 'Subir Libro',
      visible: true, // Siempre visible
    },
    {
      key: '4',
      icon: <UploadOutlined />,
      label: 'Subir Recurso',
      visible: true, // Siempre visible
    },
    {
      key: '5',
      icon: <UserSwitchOutlined />,
      label: 'Usuarios',
      visible: rol === 'RECTOR', // Solo visible para RECTOR
    },
    {
      key: '6',
      icon: <CloseSquareOutlined />,
      label: 'Cerrar Sesión',
      visible: true, // Siempre visible
    },
  ];

  // Filtrar elementos del menú según el rol
  const filteredMenuItems = menuItems.filter(item => item.visible);

  return (
    <ConfigProvider
      theme={{
        algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
    >
      <Layout style={{ minHeight: '100vh', background: bgColor }}>
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{
            background: darkMode ? '#001529' : '#fff',
            transition: 'all 0.3s',
            position: 'fixed', // Asegurar que el menú se quede fijo a la izquierda
            top: 0,
            bottom: 0,
            zIndex: 1000,
          }}
        >
          <div style={{ textAlign: 'center', padding: '16px' }}>
            <img
              src="/favicon.png"
              alt="Logo"
              style={{ width: '80%', maxWidth: '100px', height: 'auto' }}
            />
            {username && (
              <div
                style={{
                  marginTop: 12,
                  fontWeight: 'bold',
                  color: darkMode ? '#fff' : '#000',
                  wordBreak: 'break-word',
                }}
              >
                {username}
              </div>
            )}
            {rol && (
              <div
                style={{
                  marginTop: 12,
                  fontWeight: 'bold',
                  color: darkMode ? '#fff' : '#000',
                  wordBreak: 'break-word',
                }}
              >
                {rol}
              </div>
            )}
          </div>
          {!collapsed && (
            <Menu
              theme={darkMode ? 'dark' : 'light'}
              mode="inline"
              selectedKeys={[selectedMenuKey]}
              onClick={handleMenuClick}
              items={filteredMenuItems}
            />
          )}
          {!collapsed && (
            <div
              style={{
                padding: '16px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <LightModeOutlinedIcon
                fontSize="small"
                style={{ color: darkMode ? '#fff' : '#000' }}
              />
              <Switch
                checked={darkMode}
                onChange={setDarkMode}
                checkedChildren="Oscuro"
                unCheckedChildren="Claro"
              />
              <DarkModeOutlinedIcon
                fontSize="small"
                style={{ color: darkMode ? '#fff' : '#000' }}
              />
            </div>
          )}
          {collapsed && (
            <div
              style={{
                padding: '16px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Button
                shape="circle"
                icon={darkMode ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
                onClick={() => setDarkMode(!darkMode)}
                style={{
                  color: darkMode ? '#fff' : '#000',
                  border: 'none',
                  background: 'transparent',
                }}
              />
            </div>
          )}
        </Sider>
        <Layout style={{ marginLeft: collapsed ? 0 : 200 }}>
          <Header style={{ padding: 0, background: headerBg }}>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: '16px',
                width: 64,
                height: 64,
              }}
            />
          </Header>
          <Content
            style={{
              margin: '24px 16px',
              padding: 24,
              minHeight: 280,
              background: darkMode ? '#141414' : '#fff',
              borderRadius: '8px',
              color: darkMode ? '#fff' : '#000',
            }}
          >
            {selectedMenuKey === '1' && <Perfil />}
            {selectedMenuKey === '2' && <RecursosGenerales />}
            {selectedMenuKey === '3' && <SubirLibro />}
            {selectedMenuKey === '4' && <SubirRecurso />}
            {selectedMenuKey === '5' && <UsuariosList />}
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default Home;
